// src/components/shared/KPICard.js
import React from 'react';
import { TrendingUp } from 'lucide-react';

const KPICard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  comparison = null,
  trend = null, // Legacy support
  compactComparison = false, // Hide "vorige periode" text
  className = ""
}) => {
  // Use comparison if provided, otherwise fall back to trend
  const displayComparison = comparison !== null ? comparison : trend;

  // Determine comparison state
  const getComparisonState = () => {
    if (displayComparison === null || displayComparison === undefined || isNaN(displayComparison)) return null;
    if (displayComparison > 0) return 'positive';
    if (displayComparison < 0) return 'negative';
    return 'neutral';
  };

  const comparisonState = getComparisonState();

  return (
    <div className={`kpi-card ${className}`}>
      <div className="kpi-card-content">
        {/* Icon */}
        <div className="kpi-icon-wrapper">
          <Icon className="kpi-icon" strokeWidth={2.5} />
        </div>

        {/* Content - Centered */}
        <div className="kpi-data">
          <p className="kpi-title">{title}</p>
          <p className="kpi-value">{value}</p>
          {subtitle && <p className="kpi-subtitle">{subtitle}</p>}

          {comparisonState && (
            <div className={`kpi-comparison ${comparisonState}`}>
              <TrendingUp className={`kpi-trend-icon ${comparisonState === 'negative' ? 'rotate-180' : ''}`} />
              {displayComparison > 0 ? '+' : ''}{displayComparison}%{!compactComparison && ' vorige periode'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default KPICard;
